var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollableY"},[_c('div',{staticClass:"container has-text-white"},[_c('div',{staticClass:"top80"},[_c('div',{staticClass:"is-size-3"},[_vm._v("ADS")]),_c('br'),_vm._l((_vm.ads),function(item,index){return _c('ad-metrics',{key:index,attrs:{"item":item,"ind":index}})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }